export default "__VITE_ASSET__DqJOHwVz__"